import { Injectable } from '@angular/core';
import { Loader } from 'src/app/dataModels/loader';
import { BehaviorSubject } from 'rxjs';
/**
 * Loading service
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  /**
   * loader
   */
  loader = new BehaviorSubject<Loader>({ showLoading: false, loadingMessage: '', isComponent: false });

  /**
   * constructor to inject dependency
   */
  constructor() {}

  /**
   * display loading indicators
   */
  showLoading() {
    return this.loader.asObservable();
  }

  /**
   * display loader
   * @param loadingMessage loading message
   * @param isComponent indicate if its for a component or entire page
   */
  displayLoader(loadingMessage: string = '', isComponent = false) {
    this.loader.next({ showLoading: true, loadingMessage:"", isComponent });
  }

  /**
   * hide loader
   */
  hideLoader() {
    this.loader.next({ showLoading: false, loadingMessage: '', isComponent: false });
  }
}
